<igo-catalog-library
  [predefinedCatalogs]="predefinedCatalogs()"
  [addCatalogAllowed]="addCatalogAllowed()"
  [store]="store"
  (catalogSelectChange)="onCatalogSelectChange($event)"
/>
@if (exportButton()) {
  <div class="get-catalog-list-button">
    <button
      matButton="elevated"
      [matTooltip]="
        'igo.integration.catalog.library.getCatalogList' | translate
      "
      matTooltipPosition="above"
      color="primary"
      (click)="getCatalogList()"
    >
      {{ 'igo.integration.catalog.library.getCatalogList' | translate }}
    </button>
  </div>
}
